var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawPencil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39935 2.12671C3.32185 4.58504 0.88435 8.15171 1.78685 9.26671C3.55018 11.4442 8.63268 5.41421 10.2535 7.64338C11.8752 9.87254 5.78352 12.2109 8.92185 15.4017",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5137 8.96679L14.522 15.8793C14.4444 16.0139 14.3307 16.1242 14.1937 16.1976L11.5195 17.6293V14.6435C11.5195 14.4972 11.5581 14.3535 11.6312 14.2268L15.6295 7.30179C15.8556 6.93015 16.218 6.66172 16.6394 6.55391C17.0608 6.4461 17.5077 6.50748 17.8844 6.72491C18.2611 6.94234 18.5378 7.29857 18.6553 7.71738C18.7727 8.13619 18.7216 8.58434 18.5129 8.96595L18.5137 8.96679Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawPencil);
export default __webpack_public_path__ + "static/media/draw-pencil.5c7971667db8e8d9c023007bd8cd8a66.svg";
export { ForwardRef as ReactComponent };